import PropTypes from 'prop-types';
import React from 'react';
import styles from './RCUIBadge.scss';

const RCUIBadge = ({ type, text, classNames = '' }) => (
  <span
    role="presentation"
    className={`${styles.default} ${type ? styles[type] : ''} ${classNames}`}
  >
    {text}
  </span>
);

RCUIBadge.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['default', 'dark']),
  classNames: PropTypes.string,
};

export default RCUIBadge;
